/* eslint-disable react/forbid-prop-types */

import React, { useState, useEffect, useRef } from 'react';
import Select from 'react-select';
import moment from 'moment';
import { Row, Col, Card, CardText, CardBody, CardTitle } from 'reactstrap';
import PropTypes from 'prop-types';
import MonthlyBarChart from './MonthlyBarChart';
import { sortByOptions } from '../../helper'


const CategorySalesByMonth = ({ dir, dataToShowForDatesSelected, monthsBetweenDates, title,
    categorisedBasedOn, viewReportButton,
    height, isSalesKey, currentlyShow }) => {

    const categorisedBasedOnRef = useRef({ categorisedBasedOn });

    const [selectedOptions, setSelectedOptions] = useState([])
    const [sortBySelected, setSortBySelected] = useState(sortByOptions[1])
    const allCategories = {}
    const currentDataByCategory = {};
    let dataToPlot = [];

    useEffect(() => {
        if (categorisedBasedOnRef?.current?.categorisedBasedOn !== categorisedBasedOn) {
            setSelectedOptions([])
        }
    }, [categorisedBasedOn])

    const changeFilter = (value) => {
        setSelectedOptions(value)
    };

    dataToShowForDatesSelected.forEach((item) => {
        if (item && currentDataByCategory[item?.[categorisedBasedOn]]) {
            currentDataByCategory[item?.[categorisedBasedOn]]?.push(item)
        } else if (item) {
            if (!item?.[categorisedBasedOn] || item?.[categorisedBasedOn] === 'null') {
                currentDataByCategory?.['N/A']?.push(item)
            } else {
                currentDataByCategory[item?.[categorisedBasedOn]] = [item]
            }
        }
    });

    const currentMonthCat = Object.keys(currentDataByCategory);
    //  let dataToPlot = [];
    const options = [];

    const reduceCallback = (acc, day) => {
        const date = moment(`${day.salesMonth}-${day?.salesYear}`, 'MMM-YYYY');
        const MonthYear = date.format('MMM-YYYY');
        if (acc[MonthYear]) {
            acc?.[MonthYear]?.push(day)
        } else {
            acc[MonthYear] = [day]
        }

        if (day && !allCategories[day?.[categorisedBasedOn]]) {
            if (!day?.[categorisedBasedOn] || day?.[categorisedBasedOn] === 'null') {
                allCategories['N/A'] = 'N/A';
            } else {
                allCategories[day?.[categorisedBasedOn]] = day?.[categorisedBasedOn]
            }
        }
        return acc
    }

    for (let i = 0; i < currentMonthCat.length; i += 1) {
        const cat = currentMonthCat[i];
        const currentMonth = currentDataByCategory?.[cat] ?? [];
        let currentYearMonthMax = 0;
        currentMonth?.forEach((item) => {
            currentYearMonthMax += Number(item.amount)
        }
        );
        const currentYearMonthDayWise = currentMonth?.reduce(reduceCallback, {})
        const categoryWiseAmountTotal = Object.keys(currentYearMonthDayWise).reduce((acc, monthyear) => {
            const [curmonth, year] = monthyear?.split('-');
            const date = moment(`${curmonth}-${year}`, 'MMM-YYYY');
            const preMonthYear = moment(date).subtract(1, 'months').endOf('month').format('MMM-YYYY');
            let amount = currentYearMonthDayWise[monthyear]?.reduce((accum, item) => Number(Number(Number(accum) +
                Number(item.amount)).toFixed(2)), 0);
            amount = Math.abs(amount);
            const orderCount = currentYearMonthDayWise[monthyear]?.reduce((accOrder, itemOrder) =>
                Number(Number(accOrder) + Number(itemOrder.orderCount)), 0)
            const preAmount = currentYearMonthDayWise[preMonthYear]?.reduce((accPre, item) =>
                Number(Number(Number(accPre) + Number(item.amount)).toFixed(2)), 0) ?? 0;

            //  const percentageAmount = getPercentage(amount, preAmount) ?? 0;
            //  const cardColorCode = getColorCode(percentageAmount);
            acc[monthyear] = { Amount: amount };
            return acc
        }, {})
        options.push({
            value: cat, label: cat
        })
        dataToPlot.push({
            title: cat,
            categoryWiseAmountTotal,
            currentYearMonthMax: currentYearMonthMax > 0 ? currentYearMonthMax : 0
        })

    }

    if (selectedOptions?.length) {
        const selected = selectedOptions?.reduce((acc, item) => {
            acc[item?.value] = item.value
            return acc
        }, {})
        dataToPlot = dataToPlot.filter(item => selected[item.title])
    }

    const sortBy = sortBySelected?.value;

    if (sortBy === 'title') {
        dataToPlot = dataToPlot?.sort((a, b) =>
            a?.[sortBy]?.toLowerCase() > b?.[sortBy]?.toLowerCase() ? 1 : -1)
    } else {
        dataToPlot = dataToPlot?.sort((a, b) =>
            a?.[sortBy] < b?.[sortBy] ? 1 : -1)
    }

    return (
        <>
            <div className="card__title row ">
                <h5 className="bold-text col-md-4">{title}</h5>
                <div className="form__form-group mb-0 col-md-7" id="dvChartFilter">
                    <div className="row justify-content-center align-items-center">
                        <div className="col-6">
                            <span className="form__form-group-label font-weight-bold">
                                {`Select ${currentlyShow?.value}`}</span>
                            <div className="form__form-group-field">
                                <Select
                                    value={selectedOptions}
                                    options={options}
                                    clearable={false}
                                    placeholder={`Select ${currentlyShow?.value}`}
                                    className="select_filter"
                                    onChange={changeFilter}
                                    classNamePrefix="react-select"
                                    isMulti

                                />
                            </div>
                        </div>
                        <div className="col-4">
                            <span className="form__form-group-label font-weight-bold">Sort By</span>
                            <div className="form__form-group-field">
                                <Select
                                    value={sortBySelected}
                                    options={sortByOptions}
                                    clearable={false}
                                    placeholder="Sort By"
                                    className="select_filter-110"
                                    onChange={setSortBySelected}
                                    classNamePrefix="react-select"
                                />
                            </div>

                        </div>
                    </div>
                </div>
                <div className="col-1" id="dvChartView">
                    {viewReportButton?.()}
                </div>
            </div>

            {dataToPlot.length ? dataToPlot?.map((category, index) => (<Row key={category.title}>
                <Col sm={4} md={2}><CardText>{category.title}</CardText></Col>
                <Col sm={8} md={10}><MonthlyBarChart dir={dir}
                    currentYearMonthDayWise={category.categoryWiseAmountTotal}
                    height={275}
                    showTitle={false}
                    categorisedBasedOn={categorisedBasedOn}
                    allCategories={allCategories}
                    isSalesKey={isSalesKey}
                    index={index}
                    month={monthsBetweenDates}
                    category={category.title}
                /></Col>
            </Row>
            )) : <div className="no-data">No data to display</div>}
        </>
    )
}

CategorySalesByMonth.propTypes = {
    dir: PropTypes.string.isRequired,
    dataToShowForDatesSelected: PropTypes.array.isRequired,
    monthsBetweenDates: PropTypes.array.isRequired,
    viewReportButton: PropTypes.func.isRequired,
    title: PropTypes.string,
    categorisedBasedOn: PropTypes.string,
    height: PropTypes.number.isRequired,
    isSalesKey: PropTypes.string,
    currentlyShow: PropTypes.object.isRequired,
}

CategorySalesByMonth.defaultProps = {
    title: 'Category Sales By Month',
    categorisedBasedOn: 'productCategory',
    isSalesKey: 'amount'
}

export default CategorySalesByMonth;